import script from "./CreateRule.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRule.vue?vue&type=script&setup=true&lang=js"

import "./CreateRule.vue?vue&type=style&index=0&id=a5466e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5466e64"]])

export default __exports__